/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1InsidebulksQueryResponse } from '../../types/GetV1Insidebulks.ts'

export const getV1InsidebulksQueryKey = () => [{ url: '/v1/InsideBulks' }] as const

export type GetV1InsidebulksQueryKey = ReturnType<typeof getV1InsidebulksQueryKey>

/**
 * {@link /v1/InsideBulks}
 */
export async function getV1Insidebulks(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1InsidebulksQueryResponse, ResponseErrorConfig<Error>, unknown>({
        method: 'GET',
        url: `/v1/InsideBulks`,
        ...requestConfig,
    })
    return res
}

export function getV1InsidebulksQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1InsidebulksQueryKey()
    return queryOptions<
        ResponseConfig<GetV1InsidebulksQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1InsidebulksQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Insidebulks(config)
        },
    })
}

/**
 * {@link /v1/InsideBulks}
 */
export function useGetV1Insidebulks<
    TData = ResponseConfig<GetV1InsidebulksQueryResponse>,
    TQueryData = ResponseConfig<GetV1InsidebulksQueryResponse>,
    TQueryKey extends QueryKey = GetV1InsidebulksQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1InsidebulksQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1InsidebulksQueryKey()

    const query = useQuery(
        {
            ...getV1InsidebulksQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
